/*
 *
 * Artifactory is a binaries repository manager.
 * Copyright (C) 2018 JFrog Ltd.
 *
 * Artifactory is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 * Artifactory is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Artifactory.  If not, see <http://www.gnu.org/licenses/>.
 *
 */


export class BuildNumbersController {
	constructor($scope, $q, $timeout, $state, $stateParams, BuildsDao, JFrogEventBus, JFrogModal,
	            JFrogNotifications, User, JFrogTableViewOptions) {
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.$scope = $scope;
		this.user = User.getCurrent();
		this.$timeout = $timeout;
		this.$q = $q;
		this.buildsHistoryGridOption = {};
		this.buildTitle = 'History for Build  \'' + this.$stateParams.buildName + '\'';
		this.totalBuilds = '';
		this.buildsDao = BuildsDao;
		this.JFrogTableViewOptions = JFrogTableViewOptions;
		this.JFrogEventBus = JFrogEventBus;
		this.artifactoryNotifications = JFrogNotifications;
		this.modal = JFrogModal;
		this.firstFetch = true;

		//this.JFrogEventBus.dispatch(EVENTS.BUILDS_BREADCRUMBS);

		this._createGrid();
		this._getBuildsData();
	}

	deleteBuild(row) {
		let json = {
			buildsCoordinates: [
				{
					buildName: this.$stateParams.buildName,
					buildNumber: row.buildNumber,
					date: row.time
				}
			]
		};
		this.modal.confirm(
			'Are you sure you wish to delete the build \'' + this.$stateParams.buildName + '\'#' + row.buildNumber + '?')
		    .then(() => {
			    this.buildsDao.delete(json).$promise.then(() => {
				    this._getBuildsData();
			    });
		    });
	}

	bulkDelete() {
		let selectedRows = this.buildsHistoryGridOption.api.selection.getSelectedRows();
		let confirmMessage = 'Are you sure you wish to delete ' + selectedRows.length;
		confirmMessage += selectedRows.length > 1 ? ' builds?' : ' build?';

		this.modal.confirm(confirmMessage)
		    .then(() => {
			    let buildsToDelete = selectedRows.map(build => {
				    return {
					    buildName: this.$stateParams.buildName,
					    buildNumber: build.buildNumber,
					    date: build.time
				    };
			    });
			    //console.log(buildsToDelete);
			    let json = {
				    buildsCoordinates: buildsToDelete
			    };
			    this.buildsDao.delete(json).$promise.then(() => {
				    this._getBuildsData();
			    });
		    });
	}

	_getBuildsData(pagination) {
		if (pagination) {
			if (this.firstFetch) {
				this.firstFetch = false;
				pagination.orderBy = 'build_number';
				pagination.direction = 'asc';
			}
			return this.buildsDao.getData(pagination, {
				action: 'history',
				name: this.$stateParams.buildName
			}).$promise;
		} else {
			let defaultPagination = {
				pageNum: 1,
				numOfRows: 25,
				direction: 'asc',
				orderBy: 'build_number'
			};

			this.buildsDao.getData(defaultPagination, {
				action: 'history',
				name: this.$stateParams.buildName
			})
			    .$promise.then((data) => {
				this.tableViewOptions.setData(data.pagingData);
			});
		}
	}

	_createGrid() {
		this.tableViewOptions = new this.JFrogTableViewOptions(this.$scope);
		this.tableViewOptions.setColumns(this._getColumns());
		//this.tableViewOptions.setExternalPagination((pagination) => this._getBuildsData(pagination));
		this.tableViewOptions.setSelection(this.tableViewOptions.MULTI_SELECTION);
		this.tableViewOptions.setActions(this._getActions());
		this.tableViewOptions.setBatchActions(this._getBatchActions());

	}

	_getColumns() {

		return [
			{
				header: 'Build ID',
				field: 'buildNumber',
				cellTemplate: `<div class="ui-grid-cell-contents">
									<a href="" style="color: #373737"
										ng-click="grid.appScope.BuildNumbers.onClick(row.entity.buildNumber, row.entity.time)" 
										id="build-id">{{row.entity.buildNumber}}
									</a>
								</div>`,
				width: '40%'
			},
			{
				header: 'CI Server',
				field: 'ciUrl',
				cellTemplate: '<div class="ui-grid-cell-contents"><a href="{{row.entity.ciUrl}}" target="_blank" id="ci-server">{{row.entity.ciUrl}}</a></div>',
				width: '30%'
			},
			{
				header: 'Status',
				field: 'releaseStatus',
				cellTemplate: '<div class="ui-grid-cell-contents" id="status">{{row.entity.releaseStatus}}</div>',
				allowGrouping: true,
				width: '10%'
			},
			{
				header: 'Build Time',
				cellTemplate: '<div class="ui-grid-cell-contents" id="build-time">{{row.entity.lastBuildTime}}</div>',
				field: 'time',
				sort: {
					direction: 'desc'
				},
				type: 'number',
				width: '20%'
			}

		];
	}

	onClick(buildNumber, startTime) {
		//	    this.JFrogEventBus.dispatch(EVENTS.BUILDS_BREADCRUMBS, name);
		// ui-sref="builds.build_page({buildName:grid.appScope.BuildNumbers.$stateParams.buildName,buildNumber:row.entity.buildNumber,startTime:row.entity.time,tab:'general'})"
		this.$state.go('builds.build_page', {
			buildName: this.$stateParams.buildName,
			tab: 'general',
			startTime,
			buildNumber
		});
	}

	_getActions() {
		return [
			{
				icon: 'icon icon-clear',
				tooltip: 'Delete',
				callback: row => this.deleteBuild(row),
				visibleWhen: () => this.user.isAdmin()
			}

		];
	}

	_getBatchActions() {
		return [
			{
				icon: 'clear',
				name: 'Delete',
				callback: () => this.bulkDelete(),
				visibleWhen: () => this.user.isAdmin()
			}
		];
	}

	backToBuilds() {
		this.$state.go('builds.all');
	}
}



// WEBPACK FOOTER //
// ./states/builds/build_numbers/build_numbers.controller.js